import { Component } from "@angular/core";
import { KpiGridPanelComponent } from "../kpi-grid-panel/kpi-grid-panel.component";
import { NewUiKpiGridViewComponent } from "./new-ui-kpi-grid-view.component";

@Component({
  selector: "app-kpi-grid-view",
  templateUrl: "./kpi-grid-view.component.html",
  styleUrl: "./kpi-grid-view.component.scss",
  imports: [KpiGridPanelComponent],
})
export class KpiGridViewComponent extends NewUiKpiGridViewComponent {}
